import { render } from "./SettingsButton.vue?vue&type=template&id=193b4aea&scoped=true&ts=true&lang=pug"
import script from "./SettingsButton.vue?vue&type=script&lang=ts"
export * from "./SettingsButton.vue?vue&type=script&lang=ts"

import "./SettingsButton.vue?vue&type=style&index=0&id=193b4aea&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193b4aea"]])

export default __exports__